/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React from 'react';
import { Route, Switch } from 'react-router';
import LandingPage, { CallbackLoadingPage } from 'views/Onboarding/Callback';
import { NotFoundRedirect } from './utils';


export default ({ match }) => (
  <Switch>

    <Route path={`${match.url}/loading`} exact={true}>
      <CallbackLoadingPage />
    </Route>

    {/* Special route to return parameters back from a 3rd party url */}
    <Route path={`${match.url}`} exact={true}>
      <LandingPage />
    </Route>

    {NotFoundRedirect}
  </Switch>
);
